"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./IncomingCall.module.css";
import { STATUS } from "../common/const";

// const _interactionsData = JSON.parse(
//   '{"events":{"e-979":{"id":"e-979","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-27","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-980"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"f3fb1290-1cc5-4883-b713-39103031224f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721373450656},"e-981":{"id":"e-981","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-64","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-982"}},"mediaQueries":["main","medium","small","tiny"],"target":{"appliesTo":"ELEMENT","styleBlockIds":[],"id":"1b401737-38a5-0d94-9e00-504faedee7a5"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1721374358023}},"actionLists":{"a-27":{"id":"a-27","title":"incoming call [hide]","actionItemGroups":[{"actionItems":[{"id":"a-27-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".incoming-call","selectorGuids":["86ff3756-9d39-8af7-66dc-8e11123ab41d"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1701793375180},"a-64":{"id":"a-64","title":"incoming call [show]","actionItemGroups":[{"actionItems":[{"id":"a-64-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"value":"flex","target":{"selector":".incoming-call","selectorGuids":["86ff3756-9d39-8af7-66dc-8e11123ab41d"]}}}]}],"createdOn":1721374360582,"useFirstGroupAsInitialState":false}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
// );

export function IncomingCall({
  as: _Component = _Builtin.Block,
  avatarImage = "images/66968578d5889c78730e31f3_avatar_01.png",
  callFrom = "Patrick Jenkins",
  textNumber = "(208) 555-0112",
  callStatus = "",
  handleHangUp = () => { },
  handleAcceptCall = () => { },
}) {
  // _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component className={"incoming-call"} tag="div" style={{ display: callStatus === STATUS.INCOMING ? "flex" : "none"}}>
      <_Builtin.Block
        className={_utils.cx(_styles, "incomingcall_left")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "notification_textcontents_top")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "notificationavatar")}
            tag="div"
          >
            <_Builtin.Image
              className={_utils.cx(_styles, "avatar_image")}
              loading="lazy"
              width="auto"
              height="auto"
              alt=""
              src={avatarImage}
            />
          </_Builtin.Block>
          <_Builtin.Block
            className={_utils.cx(_styles, "username", "larger")}
            tag="div"
          >
            {callFrom}
          </_Builtin.Block>
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "notification_textcontents_bot")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(
              _styles,
              "previewtext",
              "larger",
              "text-white"
            )}
            tag="div"
          >
            {textNumber}
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
      <_Builtin.Block
        className={_utils.cx(_styles, "notification_link_right")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "notificationicon_callaccept")}
          tag="div"
          onClick={handleAcceptCall}
        >
          <_Builtin.Image
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="images/66968578d5889c78730e319d_home_icon_03-white.svg"
          />
        </_Builtin.Block>
        <_Builtin.Block
          className={_utils.cx(_styles, "notificationicon_calldecline")}
          data-w-id="f3fb1290-1cc5-4883-b713-39103031224f"
          tag="div"
          onClick={handleHangUp}
        >
          <_Builtin.Image
            loading="lazy"
            width="auto"
            height="auto"
            alt=""
            src="images/66968578d5889c78730e31ac_dialer_04.svg"
          />
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
